import { render, staticRenderFns } from "./FarmerReport.vue?vue&type=template&id=be202554&scoped=true"
import script from "./FarmerReport.vue?vue&type=script&lang=js"
export * from "./FarmerReport.vue?vue&type=script&lang=js"
import style0 from "./FarmerReport.vue?vue&type=style&index=0&id=be202554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be202554",
  null
  
)

export default component.exports